import * as React from 'react';

var _path, _path2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36 10.636l-.5.5v11.78l.5.5h18.283l.5-.5v-11.78l-.468-.468-.01-.032H7.36zm.5 1.378v10.402h17.283v-10.34l-8.321 5.446h-.548l-8.415-5.508zm16.128-.378H9.107l7.44 4.87 7.441-4.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.508 1.5c-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5 8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5zM.008 17C.008 7.887 7.395.5 16.508.5s16.5 7.387 16.5 16.5-7.388 16.5-16.5 16.5C7.395 33.5.008 26.113.008 17z"
  })));
}

export { SvgEmail as default };